import { useCallback, useEffect, useState } from 'react';
import { getProfile } from '../services/profile';
import { isPersonalInfoComplete } from '../utils/profileCompleteness';

/**
 * Décide si le pop-up « complète ton profil » doit s'afficher. `active` n'est vrai qu'APRÈS les
 * gates obligatoires (session + CGU + date de naissance). On lit le profil persisté : si incomplet,
 * le pop-up s'affiche UNE fois par session (`dismiss` le ferme sans le rouvrir ; il revient au
 * prochain lancement, nouveau montage). Erreur de lecture → jamais affiché (fail-safe, comme les gates).
 */
export function useProfileNudge(active: boolean) {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!active || dismissed) return;
    let alive = true;
    getProfile()
      .then((profile) => {
        if (alive && !isPersonalInfoComplete(profile)) setVisible(true);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [active, dismissed]);

  const dismiss = useCallback(() => {
    setDismissed(true);
    setVisible(false);
  }, []);

  return { visible, dismiss };
}
